import * as React from 'react';
import '../../../../../commons/result-page/ResultPage.css';

interface Props {
  title: string;
  message: string;
}

class IncompleteProfileComponent extends React.PureComponent<Props> {

  render(): React.ReactNode {
    return (

      <section className="success-page">
        <div className="row">
          <div className="col-lg-10 col-lg-offset-1 text-center">
              <div className="gap-20"/>
              <span className="alerted-circle"/>
              <div className="gap-20"/>
              <p>
                <strong>
                  {this.props.title}
                </strong>
              </p>
              <p>
                {this.props.message}
              </p>
              <div className="gap-20"/>
          </div>
        </div>
      </section>

    );
  }
}

export default IncompleteProfileComponent;


// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/confirm-profile/IncompleteProfile.component.tsx